// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCj4oEstpoVstlmixcqWnWr2_48YD05Y5c",
  authDomain: "event-dde96.firebaseapp.com",
  projectId: "event-dde96",
  storageBucket: "event-dde96.firebasestorage.app",
  messagingSenderId: "756716612381",
  appId: "1:756716612381:web:5f5698518721fa31f4cff4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const fireDB = getFirestore(app);
const auth = getAuth(app);

export { fireDB, auth,app }